export const calculatePercentage = (numberOfValue: number, total: number) => {
  return Math.round((numberOfValue / total) * 100);
};
